import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import { useScrollHeader, useIntoViewAnimation, useIsMobile } from '../../hooks';
import './companyNews.less';

export default function CompanyNews({ setHeaderDark }) {
  // 使用自定义 Hook
  useScrollHeader(setHeaderDark, 50); // 50px 触发

  const navigate = useNavigate();
  const newsData = [
    {
      title: 'Cell Reports重磅：首次揭示成人弱视神经学病理机制，首创全龄优效弱视诊疗方案',
      date: '2026-06',
      desc: '北京时间 2021 年 12 月 14 日，国际顶级学术期刊《Cell Reports》在线发表了由复旦大学附属眼耳鼻喉科医院文雯团队和中科院生物物理所张朋团队领衔的研究成果《成人人类弱视中膝状 - 纹状与皮质 - 顶盖通路的层选择性信号缺失与增强》。该研究联合 3T 和 7T 超高分辨率 BOLD fMRI 技术，结合精心设计的大细胞（M）/ 小细胞（P）通路特异性视觉刺激，对 17 名单侧弱视成人患者和 17 名正常对照者进行了对照研究，取得了里程碑式的发现',
      img: './images/news/cellReportsAmblyopia5.jpg',
      route: '/newsInfo/cellReportsAmblyopia'
    },
    {
      title: '出圈2026VC！｜集视医疗发布“全龄弱视诊疗黑科技”：基于脑科学机制，突破年龄限制',
      date: '2026-06',
      desc: '津门聚智，睛启新篇！备受行业瞩目的2026视觉健康创新发展国际会议（Vision China 2026）近日在天津圆满落幕。',
      img: './images/news/jishiAllAgeAmblyopia8.jpg',
      route: '/newsInfo/jishiAllAgeAmblyopia'
    },
    {
      title: '突破弱视诊疗年龄瓶颈，集视医疗携脑科学驱动方案亮相全国小儿眼科年会',
      date: '2026-06',
      desc: '以“脑科学机制驱动・眼脑融合创新”为核心定位的集视医疗，在2026中华医学会斜视与小儿眼科学术大会上精彩亮相，向业界展示了旗下基于脑科学机制的弱视治疗解决方案——埃尔塔（ARTA），与全国眼科专家共探弱视诊疗前沿路径，引发行业广泛关注与认可。',
      img: './images/news/pediatricConference8.jpg',
      route: '/newsInfo/pediatricConference'
    },
    {
      title: '温州医科大学附属眼视光医院＆集视医疗战略合作签约',
      date: '2024-10-31',
      desc: '2024年10月，集视医疗与温州医科大学附属眼视光医院达成了一项具有里程碑意义的战略合作协议。根据协议，集视医疗的视功能训练产品将正式入驻温州医科大学附属眼视光医院的视功能训练室…',
      img: './images/news/news1.png',
      route: '/newsInfo/contract'
    },
    // {
    //   title: '集视医疗弱视方案临床试验初步访视结果出炉，001号患者4周基本治愈！',
    //   date: '2024-10-11',
    //   desc: '苏州集视医疗科技有限公司（以下简称“集视医疗”）于国内由复旦大学附属眼耳鼻喉科医院牵头，联合多中心开展的全球首个“基于AR技术的全年龄段弱视治疗方案的有效性和安全性”的前瞻性…',
    //   img: './images/news/news2.png',
    //   route: '/newsInfo/amblyopiaClinical'
    // },
    {
      title: '集视医疗亮相中华医学会第二十八次眼科学术大会',
      date: '2024-09-04',
      desc: '2024年9月4-8日，中华医学会第二十八次眼科学术大会在武汉国际博览中心隆重举行，作为年度眼科行业最盛大的学术会议，全球逾万名专家、学者相聚于此，交流分享眼科和视觉科学方面最新研究成果…',
      img: './images/news/academic3.png',
      route: '/newsInfo/academic'
    },
    {
      title: '集视医疗完成Pre-A轮融资',
      date: '2024-08',
      desc: '据悉，集视医疗已于近期完成由复健资本独家投资的Pre-A轮融资。随着本轮资金的成功注入，集视医疗将大幅提升产能，不断巩固和拓展其全年龄段弱视治疗方案，扎实推进已获批产品的商业化进程…',
      img: './images/news/news4.png',
      route: '/newsInfo/pre'
    },
    {
      title: '卓悦榜丨集视医疗荣膺“年度智慧医疗最佳企业”奖项',
      date: '2024-04-26',
      desc: '2024年4月26日，浩悦资本正式发布了“2024第八届医疗健康投资卓悦榜”，集视医疗荣膺“年度智慧医疗最佳企业”奖项。',
      img: './images/news/bestEnterprise3.png',
      route: '/newsInfo/bestEnterprise'
    },
    {
      title: '集视医疗获远毅资本天使轮投资，为2700万全年龄段弱视患者提供基于XR技术的视觉训练方法',
      date: '2024-08',
      desc: '苏州集视医疗科技有限公司（简称“集视医疗”）宣布完成由远毅资本独家投资的天使轮融资。资金将用于其自研的基于混合现实XR技术的视觉训练方法的研发与落地。',
      img: './images/news/news6.png',
      route: '/newsInfo/invest'
    },
    {
      title: 'ARVO 2017新兴趋势和热点话题丨双眼增强现实范式用于成人弱视治疗',
      date: '2024-08',
      desc: '复旦大学附属眼耳鼻喉科医院眼科孙兴怀教授、刘红主任、文雯博士与美国加州大学的李响博士合作，将增强现实和双眼训练相结合，研发了一种双眼分视的训练新模式并用于成年弱视…',
      img: './images/news/arvo1.png',
      route: '/newsInfo/arvo'
    },
  ]

  const typeList = ['最新资讯', '产品相关', '公司资讯', '行业消息', '全部资讯']
  const [currentType, setCurrentType] = useState(0);
  const tabRefs = useRef([]);
  const [leftBtnHovered, setLeftBtnHovered] = useState(false)
  const [rightBtnHovered, setRightBtnHovered] = useState(false)

  // 计算分页
  const [currentPage, setCurrentPage] = useState(1);
  const [loadedPages, setLoadedPages] = useState(1);
  const itemsPerPage = 9;
  // 计算总页数
  const totalPages = Math.ceil(newsData.length / itemsPerPage);

  // 检测是否是移动设备
  const isMobile = useIsMobile();

  // 获取当前应该显示的数据
  const getDisplayedData = () => {
    const endIndex = isMobile ? loadedPages * itemsPerPage : currentPage * itemsPerPage;
    const startIndex = isMobile ? 0 : (currentPage - 1) * itemsPerPage;
    return newsData.slice(startIndex, endIndex);
  };
  // 展开更多
  const handleLoadMore = () => {
    if (loadedPages < totalPages) {
      setLoadedPages(loadedPages + 1);
      if (!isMobile) {
        setCurrentPage(currentPage + 1);
      }
    }
  };


  const [newsCoverHovered, setNewsCoverHovered] = useState(false)
  const [hovered, setHovered] = useState(false)

  useEffect(() => {
    window.scrollTo(0, 0); // 进入页面时滚动到顶部
  }, []);

  // 进入动画
  const ref = useRef('')
  useIntoViewAnimation({
    ref: ref,
    threshold: 0.1,
    className: 'News--ani',
  })

  return <div className="CompanyNews">
    <div className='CompanyNews_cover'>
      <div className="pageMargin">
        <div className="CompanyNews_cover-blockTop">
          <div className="of_hidden">
            {/* PC端 */}
            <div className="CompanyNews_cover-topPc flex_row flex_jc-sb">
              <div className="fz_32 fw_700 lh_38" style={{ width: '50%' }}>最新资讯</div>
              <div className="flex_row flex_jc-sb gap_16" style={{ width: '50%' }}>
                <div className="fz_20 fw_500 lh_24">Focusight®<br />News information</div>
                <div className="fz_16 fw_500 lh_24" style={{ width: '400px' }}>集视医疗最新资讯，及时了解最新活动内容及业务相关新闻动态。</div>
              </div>
            </div>
            {/* 移动端 */}
            <div className='CompanyNews_cover-topMobile flex_row flex_jc-sb'>
              <div>
                <div className="fz_18 fw_700 lh_21">最新资讯</div>
                <div className="fz_14 fw_500 lh_16 mt_4">Focusight®<br />News information</div>
              </div>
              <div className="fz_12 fw_500 lh_16" style={{ width: '170px' }}>集视医疗最新资讯，及时了解最新活动内容及业务相关新闻动态。</div>
            </div>
          </div>
        </div>
        <div className="CompanyNews_cover-blockBottom">
          <div className="of_hidden bdr_12">
            <div ref={ref} className="CompanyNews_cover-img ">
              {/* PC端图片 */}
              <img
                className='CompanyNews_cover-imgPc'
                src='./images/news/twoCitiesAcademic2.jpg'
                alt=''
              />
              {/* 移动端图片 */}
              <img
                className='CompanyNews_cover-imgMobile'
                src='./images/news/twoCitiesAcademic2.jpg'
                alt=''
              />
              <div className='CompanyNews_cover-bottomContent'>
                <div className="of_hidden">
                  {/* PC端 */}
                  <div className="CompanyNews_cover-block CompanyNews_cover-blockPc c_ff">
                    <div className="CompanyNews_cover-blockText">
                      <div className="fz_32 fw_700 lh_38 pt_30 ml_22 mr_20 ellipsis">深耕临床前沿，聚力视康革新｜集视双城眼科学术盛会完美落幕</div>
                      <div className="fz_16 fw_500 lh_18 mt_10 ml_22 mr_20 mb_20 multiline-ellipsis" style={{ maxWidth: '540px' }}>6月4日-7日，集视医疗双线奔赴宁波VDT学术交流会、沈阳非公医疗眼科年会双城行业盛会。以学术交流为核心，以技术展示为载体，与全国眼科同仁共探全龄弱视诊疗新方向，共启视光康复行业新机遇。至此，集视双城学术之旅圆满收官！</div>
                    </div>
                    <div
                      className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c'
                      onClick={() => navigate('/newsInfo/twoCitiesAcademic')}
                      onMouseEnter={() => setNewsCoverHovered(true)}
                      onMouseLeave={() => setNewsCoverHovered(false)}
                    >
                      <div>阅读文章</div>
                      <img
                        className='Wearable_product-rightArrow'
                        src={newsCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                        alt=''
                      />
                    </div>
                  </div>
                  {/* 移动端 */}
                  <div className="CompanyNews_cover-block CompanyNews_cover-blockMobile c_ff">
                    <div className="CompanyNews_cover-blockText flex_col flex_jc-sb">
                      <div className='ml_20 mr_50 mt_20'>
                        <div className="fz_18 fw_700 lh_21">深耕临床前沿，聚力视康革新｜集视双城眼科学术盛会完美落幕</div>
                        <div className="fz_12 fw_500 lh_16 mt_10 multiline-ellipsis-5">6月4日-7日，集视医疗双线奔赴宁波VDT学术交流会、沈阳非公医疗眼科年会双城行业盛会。以学术交流为核心，以技术展示为载体，与全国眼科同仁共探全龄弱视诊疗新方向，共启视光康复行业新机遇。至此，集视双城学术之旅圆满收官！</div>
                      </div>
                      <div
                        className='Fcst_cover-btn flex_row flex_jc-c flex_ai-c ml_20 mb_20'
                        onClick={() => navigate('/newsInfo/twoCitiesAcademic')}
                        onMouseEnter={() => setNewsCoverHovered(true)}
                        onMouseLeave={() => setNewsCoverHovered(false)}
                      >
                        <div>阅读文章</div>
                        <img
                          className='Wearable_product-rightArrowMobile'
                          src={newsCoverHovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                          alt=''
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="CompanyNews_content bgc_F5F9FD">
      <div className="pageMargin">
        <div className="CompanyNews_content-top">
          <div className="of_hidden">
            <div className="CompanyNews_content-topBlock c_85899E flex_row flex_jc-c">
              {typeList.map((i, index) => <div
                key={index}
                ref={el => tabRefs.current[index] = el}
                className={`CompanyNews_bottomContent-typeItem cur_p ${index === currentType ? 'active' : ''}`}
                onClick={(() => setCurrentType(index))}
              >
                {i}</div>)}
            </div>
          </div>
        </div>
        <div className="CompanyNews_bottomContent-block">
          {getDisplayedData().map((item, index) => <div
            key={index}
            className="CompanyNews_content-item"
            onClick={() => {
              if (isMobile) {
                navigate(item.route)
              }
            }}
          >
            <div className="CompanyNews_content-itemImg flex_center">
              <img
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 10 }}
                src={item.img}
                alt=''
              />
              <div className="Fcst_bottomContent-btnBlock flex_center">
                <div
                  className="Fcst_bottomContent-btn cur_p"
                  onClick={(() => navigate(item.route))}
                  onMouseEnter={() => setHovered(true)}
                  onMouseLeave={() => setHovered(false)}
                >
                  <div className="fz_18 fw_500 lh_21">阅读文章</div>
                  <img
                    className='Wearable_product-rightArrow'
                    src={hovered ? './images/home/arrow-right-blackLine.png' : './images/home/arrow-right-whiteLine.png'}
                    alt=''
                  />
                </div>
              </div>
            </div>
            <div className="CompanyNews_content-itemDate c_85899E">{item.date}</div>
            <div className="CompanyNews_content-itemTitle of_ellipsis">{item.title}</div>
            <div className="CompanyNews_content-itemDesc c_85899E ellipsis_2">{item.desc}</div>
          </div>)}
        </div>
        {/* PC端分页 */}
        <div className="CompanyNews_pageBlockPc">
          {newsData.length > 9 && <div className="CompanyNews_bottomContent-page flex_row flex_jc-c flex_ai-c">
            <div
              className="CompanyNews_content-leftBtn flex_center"
              style={{ cursor: currentPage === 1 ? 'no-drop' : 'pointer' }}
              onMouseEnter={() => setLeftBtnHovered(true)}
              onMouseLeave={() => setLeftBtnHovered(false)}
              onClick={(() => {
                if (currentPage !== 1) {
                  setCurrentPage(currentPage - 1)
                }
              })}
            >
              <img
                className='Wearable_product-sliderBtnIcon'
                src={leftBtnHovered ? './images/home/whiteLeftIcon.png' : './images/home/blackLeftIcon.png'}
                alt=''
              />
            </div>
            <div className="flex_row gap_54 ml_86 mr_86">
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <div
                  key={page}
                  className={`fz_24 fw_500 lh_28 cur_p ${currentPage === page ? 'c_00' : 'c_85899E'}`}
                  onClick={() => { setCurrentPage(page) }}
                >
                  {page}</div>
              ))}
            </div>
            <div
              className="CompanyNews_content-leftBtn flex_center"
              style={{ cursor: currentPage === totalPages ? 'no-drop' : 'pointer' }}
              onMouseEnter={() => setRightBtnHovered(true)}
              onMouseLeave={() => setRightBtnHovered(false)}
              onClick={(() => {
                if (currentPage !== totalPages)
                  setCurrentPage(currentPage + 1)
              })}
            >
              <img
                className='Wearable_product-sliderBtnIcon'
                src={rightBtnHovered ? './images/home/whiteRightIcon.png' : './images/home/blackRightIcon.png'}
                alt=''
              />
            </div>
          </div>}
        </div>
        {/* 移动端——展开更多 */}
        {loadedPages < totalPages && <div className='CompanyNews_pageBlockMobile flex_row flex_jc-c'>
          <div
            className='CompanyNews_mobileBtn flex_row flex_jc-c flex_ai-c'
            onClick={handleLoadMore}
          >
            <div>展开更多</div>
            <img
              className='Wearable_product-rightArrowMobile'
              src='./images/home/arrow-down-blackLine.png'
              alt=''
            />
          </div>
        </div>}
      </div>
    </div>
    <Footer />
  </div>
}
